module.exports = __webpack_public_path__ + "img/hearts@2x.b77abc3.webp";